import React, { useRef } from "react";

import toolbarIconLibrary from "../icons/ToolbarIconLibrary";
// import "./ToolbarMenu.css";

import ToolbarSystem from "../list-units/ToolbarSystem";
import { MarkerType, MenuTypes } from "../../enums";
import { ISystemData } from "../../interfaces";

interface IMenuChoices {
  category: MenuTypes;
  title?: string;
  markers?: ISystemData[];
  showSearchBar?: boolean;
}

interface IMenuProp {
  selectedMarkerData: ISystemData | null | undefined;
  setSelectedMarkerId: Function;
  panTo: Function;
  search: string;
  setSearch: Function;
  setShowMenu: Function;
  lastSelectedMenuSystemRef: React.MutableRefObject<HTMLDivElement | null>;
}

interface IMenuProps {
  menuProps: IMenuProp;
  menuChoices: IMenuChoices;
}

function ToolbarMenu({ menuProps, menuChoices }: IMenuProps) {
  const {
    selectedMarkerData,
    setSelectedMarkerId,
    panTo,
    search,
    setSearch,
    setShowMenu,
    lastSelectedMenuSystemRef,
  } = menuProps;
  const {
    category,
    title = category,
    markers = [],
    showSearchBar = false,
  } = menuChoices;

  const selectHandler = (system: ISystemData | null) => {
    setSelectedMarkerId(system?.id);
  };

  const getListUnitByMarker = (marker: ISystemData, selected: boolean) => {
    return (
      <ToolbarSystem
        key={marker.id}
        lastSelectedRef={lastSelectedMenuSystemRef}
        markerData={marker}
        selectHandler={selectHandler}
        panTo={panTo}
        selected={selected}
      />
    );
  };

  const menuList = markers
    .filter((marker: ISystemData) =>
      String(marker.name.toUpperCase()).includes(search.toUpperCase())
    )
    .map((marker: ISystemData) =>
      getListUnitByMarker(
        marker,
        Boolean(selectedMarkerData && marker.id === selectedMarkerData.id)
      )
    );

  return (
    <span className="menu-box">
      <div
        className="menu-header"
        style={showSearchBar ? { height: "100px" } : {}}
      >
        <div
          className="menu-close"
          onClick={() => {
            setShowMenu(false);
            setSelectedMarkerId(null);
          }}
        >
          <img src={toolbarIconLibrary.chevron.left} alt="Close Menu" />
        </div>
        <div className="menu-title">
          <p>{title}</p>
        </div>
        {showSearchBar && (
          <div className="search-bar">
            <img src={toolbarIconLibrary.search.searchIcon} alt="Search" />
            <input
              type="text"
              placeholder="Type to search"
              value={search}
              onChange={(e) => {
                e.preventDefault();
                setSearch(e.target.value);
              }}
            />
            {search && (
              <img
                src={toolbarIconLibrary.search.closeIcon}
                alt="Search"
                onClick={() => {
                  setSearch("");
                }}
                style={{ float: "right", paddingRight: "35px" }}
              />
            )}
          </div>
        )}
      </div>
      <div
        className="menu-content"
        style={showSearchBar ? { height: "calc(100% - 120px)" } : {}}
      >
        {menuList}
      </div>
    </span>
  );
}

export default ToolbarMenu;
